import Moment from 'moment-timezone';
import { i18n } from '@/plugins/i18n';
import VitalityCriterion from '@/utils/classes/VitalityCategory/VitalityCriterion';


/**
 * Score based on the number of NOK items where no problems was reported.
 * An NOK item is considered valid if :
 * - a problem has been reported for this item, or
 * - a problem has been reported for the same item on another GW in the 4 days before or after
 *
 * Then the score is simply the number of valid NOK items divided by the number of NOK items
 */
export default new VitalityCriterion({
  titleTr: 'VH_GW_NOK_WITHOUT_PROBLEM',
  key: 'gwNokWithoutProblem',
  weight: 1.5,

  score: ({ completedGws }, { start, end }) => {
    // Filter completed GW for the period
    const filtered = completedGws.filter(gw => start.isBefore(gw.date) && end.isAfter(gw.date));
    const nGW = filtered.length;

    const intervalsPerTemplate = {};
    filtered.forEach((gw) => {
      gw.steps.forEach((step) => {
        step.checklists.forEach((checklist) => {
          checklist.items.forEach((item) => {
            if (item.problems && item.problems.length) {
              // Check problems reported linked to GW items and save the intervals
              // Between 4 days before the report and 4 days after the report
              const mDate = Moment(gw.date);
              const interval = {
                start: mDate.clone().subtract(4, 'day').startOf('day'),
                end: mDate.clone().add(4, 'd').endOf('day'),
              };
              intervalsPerTemplate[`${item.template}`] = [...intervalsPerTemplate[`${item.template}`] || [], interval];
            }
          });
        });
      });
    });

    let nWithoutProblems = 0;
    let nTotal = 0;
    filtered.forEach((gw) => {
      gw.steps.forEach((step) => {
        step.checklists.forEach((checklist) => {
          checklist.items.forEach((item) => {
            if (item.okValue === 0) {
              if (!(item.problems && item.problems.length)) {
                // Item is NOK and has no problems. Check if there is a problem within the intervals
                const intervals = intervalsPerTemplate[`${item.template}`] || [];
                const len = intervals.length;
                let problemInIntervals = false;
                for (let i = 0; i < len; i++) {
                  if (intervals[i].start.isBefore(gw.date) && intervals[i].end.isAfter(gw.date)) {
                    problemInIntervals = true;
                    break;
                  }
                }

                if (!problemInIntervals) {
                  nWithoutProblems++;
                }
              }
              nTotal++;
            }
          });
        });
      });
    });

    const score = nTotal === 0 ? 100 : (nTotal - nWithoutProblems) * 100 / nTotal;

    return {
      score: nGW === 0 ? 0 : score,
      data: {
        score,
        nGW,
        nTotal,
        nWithoutProblems,
      },
    };
  },

  text({ nWithoutProblems, nGW, score, nTotal }) {
    if (nGW === 0) {
      return i18n.t('message.VH_GW_NONE');
    }
    if (nTotal === 0) {
      return i18n.t('message.VH_GW_NOK_NONE');
    }
    return i18n.t('message.VH_GW_NOK_WITHOUT_PROBLEM_TEXT', {
      perc: score.sToFixed(1),
      nWithProblems: nTotal - nWithoutProblems,
      nTotal,
    });
  },

});
